import React from 'react'
import { Container } from '@scentregroup/ui'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import containerStyles from '../../../components/container.scss'
import style from './index.scss'

const NoProducts = () => (
  <Container
    className={classNames(style.noProducts, containerStyles.container)}
    type="full"
  >
    <div className={style.lead}>We&apos;re Sorry</div>
    <div className={style.main}>No products match this query</div>
    <Link to="/products" className={style.link}>
      See more products
    </Link>
  </Container>
)

export default NoProducts
